$color-base: GAINSBORO;
$color-highlight: lighten($color-base, 7%);

.skeleton {
	border-radius: 5px;
	position: relative;
	overflow: hidden;
	min-width: 20px;
	min-height: 20px;
	background: $color-base;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: linear-gradient(90deg, $color-base, $color-highlight, $color-base);
		animation: progress 1s ease-in-out infinite;
	}
}

@keyframes progress {
	0% {
		transform: translate3d(-100%, 0, 0);
	}
	100% {
		transform: translate3d(100%, 0, 0);
	}
}
